import React from "react";
import { IonChip } from "@ionic/react";
import moment from "moment";
import "../../theme/cards.css";

interface EntryCardChipProps {
    chipTitle: ChipTitleOption;
    timestamp?: string | null;
    /** If false, shows "Empty" or "Items Selected" based on hasItems. If true, shows chipTitle. */
    isRequired?: boolean;
    /** When isRequired is false: true = "Items Selected", false = "Empty" */
    hasItems?: boolean;
}

export type ChipTitleOption = "Event Info" | "Not Started" | "In Progress" | "Incomplete" | "Completed" | "Saving" | "Deleting" | "Empty" | "Item(s) Selected" | "Loading";

const EntryCardChip: React.FC<EntryCardChipProps> = ({ chipTitle, timestamp, isRequired = true, hasItems = false }) => {
    let finalChipTitle: ChipTitleOption = chipTitle;
    if (!isRequired) {
        finalChipTitle = hasItems ? "Item(s) Selected" : "Empty";
    }

    const chipColor =
        finalChipTitle === "Event Info"
            ? "info"
            : finalChipTitle === "Completed"
              ? "success"
              : finalChipTitle === "Saving"
                ? "medium"
                : finalChipTitle === "Deleting"
                  ? "danger"
                  : finalChipTitle === "Loading"
                    ? "medium"
                    : finalChipTitle === "Incomplete"
                      ? "warning"
                      : finalChipTitle === "Empty"
                        ? "medium"
                        : finalChipTitle === "Item(s) Selected"
                          ? "info"
                          : "danger";

    let chipText: string = finalChipTitle;
    if (finalChipTitle === "Completed" && timestamp) {
        const formattedDate = moment(timestamp).format("MM/DD");
        const formattedTime = moment(timestamp).format("hh:mma");
        chipText = `Completed - ${formattedDate} at ${formattedTime}`;
    } else if (finalChipTitle === "Empty") {
        chipText = "None Selected";
    }

    return (
        <IonChip
            className={"display-4.5 rounded-2 font-weight-700 text-white px-3 m-0 bg-" + chipColor}
            style={{
                // Ionic defaults to height:32px + overflow:hidden, which clips wrapped "Completed - …" text.
                height: "auto",
                minHeight: "32px",
                maxWidth: "100%",
                overflow: "visible",
                whiteSpace: "normal",
                lineHeight: 1.25,
                alignItems: "center",
                boxSizing: "border-box",
            }}>
            {chipText}
        </IonChip>
    );
};

export default EntryCardChip;
